import React from 'react';
import { HeroSection } from './sections/HeroSection';
import { DesireSection, ForYouSection, PainSection } from './sections/StorySections';
import { GuideSection } from './sections/GuideSection';
import { ModulesSection } from './sections/ModulesSection';
import { OfferSection } from './sections/OfferSection';
import { FaqSection, FinalSection, Footer, StepsSection, UrgencySection } from './sections/ClosingSections';
import { StickyCTA } from './StickyCTA';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-ink font-sans text-ivory" data-id="element-20" data-mp="kw3dsatnf3tz">
      <HeroSection data-id="element-21" data-mp="fxi8hwzjhtyo" />
      <main data-id="element-22" data-mp="fwz13a7imnyw">
        <PainSection data-id="element-23" data-mp="fwqlhak0d4k0" />
        <DesireSection data-id="element-24" data-mp="fy1r7fx0kmdr" />
        <ForYouSection data-id="element-25" data-mp="fvfi3buh5ytf" />
        <GuideSection data-id="element-26" data-mp="ayp7v55cpxfx" />
        <ModulesSection data-id="element-27" data-mp="az71rv4jjzko" />
        <OfferSection data-id="element-28" data-mp="b00ah1n28z5g" />
        <UrgencySection data-id="element-29" data-mp="awkrvou6h7za" />
        <StepsSection data-id="element-30" data-mp="6wkbvzrfkoq4" />
        <FaqSection data-id="element-31" data-mp="6vsh2r5nqv0w" />
        <FinalSection data-id="element-32" data-mp="6wapsn9ib1pp" />
      </main>
      <Footer data-id="element-33" data-mp="1xqzkanvr3rj" />
      <StickyCTA triggerId="dolor" data-id="element-34" data-mp="1x7gurqeobcg" />
    </div>;
}